import api from './client';

// Safeword API - Safety system
export const safewordAPI = {
  // Configuration
  getConfig: () => api.get('/safeword/config'),
  updateConfig: (data: {
    softLimitWord?: string;
    hardLimitWord?: string;
    customWord?: string;
    pauseTasksOnHardLimit?: boolean;
    notifyOnTrigger?: boolean;
    requireAcknowledgment?: boolean;
    cooldownMinutes?: number;
  }) => api.put('/safeword/config', data),

  // Triggering
  trigger: (level: 'soft_limit' | 'hard_limit' | 'custom', data?: {
    triggeredFrom?: string;
    relatedTaskId?: number;
    userNote?: string;
  }) => api.post('/safeword/trigger', { level, ...data }),
  triggerSoftLimit: (data?: { triggeredFrom?: string; relatedTaskId?: number; userNote?: string }) =>
    api.post('/safeword/soft-limit', data || {}),
  triggerHardLimit: (data?: { triggeredFrom?: string; relatedTaskId?: number; userNote?: string }) =>
    api.post('/safeword/hard-limit', data || {}),

  // 0zzz-uhy: a user in NO hierarchy opened the safeword page or triggered a safeword. Tells the platform admin
  // (public id + timestamp only, server side). Answers 409 for a user who is in a hierarchy.
  reportNoHierarchy: () => api.post('/safeword/no-hierarchy-alert', {}),

  // Logs
  getLogs: (params?: {
    userId?: number;
    level?: string;
    acknowledged?: boolean;
    limit?: number;
  }) => api.get('/safeword/logs', { params }),
  getMyLogs: (limit?: number) =>
    api.get('/safeword/logs/my', { params: limit ? { limit } : undefined }),
  getUnacknowledgedCount: () => api.get('/safeword/logs/unacknowledged-count'),
  getLogById: (id: number) => api.get(`/safeword/logs/${id}`),
  acknowledgeLog: (id: number, responseNotes?: string) =>
    api.post(`/safeword/logs/${id}/acknowledge`, { responseNotes }),
  addFollowup: (id: number, data: {
    completed?: boolean;
    notes?: string;
    scheduledDate?: string;
  }) => api.post(`/safeword/logs/${id}/followup`, data),

  // Statistics
  getStats: () => api.get('/safeword/stats'),

  // Task Management
  resumeTasks: (logId: number) => api.post('/safeword/resume-tasks', { logId }),

  // Personal Safewords (user-level)
  getMySafewords: () => api.get('/safeword/my-safewords'),
  updateMySafewords: (data: {
    softLimitWord?: string;
    hardLimitWord?: string;
    customWords?: string[];
    displayOnProfile?: boolean;
    showToPartner?: boolean;
  }) => api.put('/safeword/my-safewords', data),
  getPartnerSafewords: (userId: number) => api.get(`/safeword/partner-safewords/${userId}`),

  // Aftercare
  getAftercareData: (logId: number) => api.get(`/safeword/aftercare/${logId}`),
  completeAftercare: (logId: number, feedback?: string) =>
    api.post(`/safeword/aftercare/${logId}/complete`, { feedback }),
  updateAftercareSettings: (data: {
    enabled?: boolean;
    breathingExercise?: boolean;
    groundingExercise?: boolean;
    checkinDelayMinutes?: number;
    notes?: string;
    resources?: string[];
  }) => api.put('/safeword/aftercare/settings', data),

  // Force Push
  setForcePushEnabled: (enabled: boolean) => api.put('/safeword/force-push', { enabled }),

  // Admin - All Members' Safewords
  getAllMembersSafewords: () => api.get('/safeword/members-safewords'),
};
